module.exports = __webpack_public_path__ + "img/histogram-light-01.6b9b4e41.jpg";